<template>
  <div class="w-full flex justify-center" style="background: #f8fafc">
    <div class="f-container">
      <div class="default" v-if="$route.name != 'check' && !tech_works">
        <div
          class="wrapper"
          style="padding: 0"
          v-if="
            $route.name === 'login' || $route.name === 'login-oneid' || !first
          "
        >
          <div v-if="config" class="d-flex">
            <AppAside v-if="!hideBars" />
            <div style="flex: 1; overflow: hidden" class="router-content">
              <AppNavbar v-if="!hideBars && !first && config" />
              <router-view />
              <div v-if="!hideBars" class="app-footer-container">
                <div class="nav-bottom">
                  <div class="nav-bottom-div w-full sm:w-max">
                    <p
                      class="bg-white border font-bold text-slate-600 text-base leading-snug border-slate-200 rounded-lg px-2 sm:px-4 py-2"
                    >
                      {{ new Date().getFullYear() }} йил. Барча ҳуқуқлар
                      ҳимояланган.
                    </p>
                  </div>
                  <div class="flex items-center nav-bottom-div w-full sm:w-max">
                    <div class="flex items-center w-full">
                      <a
                        href="https://unicon.uz/"
                        class="w-full bg-white border font-bold text-slate-600 text-base leading-snug border-slate-200 rounded-lg flex items-center justify-center h-10 px-4"
                      >
                        <img width="110" src="@/assets/img/unicon.png" alt=""
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="config-cadaster" v-else>
            <div class="cadastre-scroll">
              <div class="config-cadaster-item">
                <h1 class="title-config">Ҳурматли фойдаланувчи!</h1>

                <table class="w-full">
                  <tr
                    v-for="(item, i) in configData"
                    :key="i"
                    class="config-text"
                  >
                    <td>
                      <span class="c-red">{{ item.cadastral_number }}</span>
                    </td>
                    <td>кадастр рақамли объект учун</td>
                    <td>
                      <span class="c-red">{{ item.number_buildings }}</span>
                    </td>
                    <td>- та бино</td>
                  </tr>
                </table>

                <p class="config-text2">
                  Мазкур объектларга тегишли биноларни тизимга киритишингиз
                  зарур. Илтимос бинолар хақида маьлумотларни тизимга тўлик
                  киритинг.
                </p>
                <div class="w-full flex justify-center">
                  <button
                    @click="(config = true), $router.push('/objects')"
                    class="config-button"
                  >
                    Тўлдириш
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <First v-else />
      </div>
      <div class="check-layout" v-else-if="!tech_works">
        <router-view />
      </div>
      <div v-else>
        <TechniqueWorks />
      </div>
    </div>
  </div>
</template>

<script>
import First from "./components/First.vue";
import TechniqueWorks from "./components/TechniqueWorks.vue";
import axios from "axios";
export default {
  components: {
    First,
    TechniqueWorks,
  },
  data() {
    return {
      now_day: "",
      now_time: "",
      back_ver: "1.0.0",
      obj: {
        profile_for_user: {},
      },
      configData: [],
      config: true,
      hideBars: true,
      tech_works: false,
    };
  },
  computed: {
    me() {
      return this.$store.state.me;
    },
    first() {
      return this.$store.state.first;
    },
    role() {
      return this.$store.state.role;
    },
  },
  watch: {
    "$route.path": function(path) {
      if (
        path != "/login" &&
        path != "/login/oneid" &&
        path != "/login/" &&
        path != "/login/oneid/"
      ) {
        this.$store.dispatch("get_unapproved_buildings");
      }
    },
    role() {
      if (
        this.role == "operator" &&
        this.$route.name != "login" &&
        this.$route.name != "login-oneid"
      ) {
        axios.get("/building/verificationobjects/").then((res) => {
          this.configData = res.data;
          if (res.data.length > 0) {
            this.config = false;
          } else {
            this.config = true;
          }
        });
      } else {
        this.config = true;
      }

      if (this.$route.name == "login" || this.$route.name == "login-oneid") {
        this.config = true;
      }
    },
    "$route.name"() {
      if (this.$route.name != "login" && this.$route.name != "login-oneid") {
        this.hideBars = false;
        if (this.$route.name == "object") {
          this.config = true;
        }
      } else {
        this.hideBars = true;
        this.config = true;
      }
    },
  },
  mounted() {
    if (localStorage.token)
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.token}`;
    // if(this.$route.name!='login' && localStorage.token!=null){ this.$store.dispatch("get_me")}
    axios.get("", { headers: { Authorization: [] } }).then((res) => {
      if (res && res.data && res.data.version) {
        this.back_ver = res.data.version;
        this.$store.commit("set_back_ver", res.data.version);
      }
    });
    setInterval(() => {
      var date = new Date();
      this.now_day =
        date.getFullYear() +
        "." +
        (date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "." +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate());
      this.now_time =
        date.getHours() +
        ":" +
        (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) +
        ":" +
        (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
    }, 1000);
  },

  updated() {
    if (
      !localStorage.token &&
      this.$route.name !== "login" &&
      this.$route.name !== "login-oneid" &&
      this.$route.name !== "check"
    ) {
      this.$router.push("/?redirect=" + this.$route.path);
    }
  },
};
</script>

<style lang="scss">
.el-select__tags {
  padding: 5px 12px !important;
  gap: 8px !important;
}
.el-select .el-tag {
  background: #f1f5f9 !important;
  border-radius: 8px !important;
  border: #000 !important;
  font-size: 14px !important;
  line-height: 1.375 !important;
  font-weight: 600 !important;
  color: #020617 !important;
  margin: 0 !important;
  height: 27px !important;
  gap: 4px !important;
}
.el-select .el-tag__close.el-icon-close {
  background: #475569 !important;
  color: #f1f5f9 !important;
  top: 0 !important;
  right: 0 !important;
  margin: 1.5px !important;
  height: 15px !important;
  width: 15px !important;
  line-height: 15px !important;
  transform: none !important;
}
.el-select .el-tag__close.el-icon-close::before {
  content: "\e6d8" !important;
}
.default {
  width: 100%;
}

.f-container {
  width: 100%;
  max-width: 2000px;
}

@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@400..900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap");

.login-one-id {
  width: 100%;
  display: flex;
  justify-content: center;

  button {
    padding: 0px 15px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    overflow: hidden;
    background: #4630c2;

    img {
      width: 100px;
    }

    i {
      color: #fff !important;
      margin-left: 10px;
      font-size: 16px !important;
      font-weight: 600 !important;
    }

    &:hover {
      i {
        animation-name: animeLogin;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in;
      }
    }
  }
}
.swal2-popup {
  border-radius: 16px !important;
  padding: 32px !important;
  width: 490px !important;
}
.swal2-header {
  padding: 0 !important;
}
.swal2-styled {
  border-radius: 12px !important;
}
.swal2-styled.swal2-cancel {
  background: #f8fafc !important;
  color: #1e293b !important;
  font-weight: 600 !important;
  &:hover {
    background: #f1f5f9 !important;
  }
  &:focus {
    box-shadow: none !important;
  }
}

@keyframes animeLogin {
  from {
    transform: translateX(0px);
  }

  from {
    transform: translateX(-10px);
  }
}

.swal2-container {
  z-index: 3000 !important;
}

.router-link {
  border-radius: 18px;
  padding: 4px 12px;
  font-weight: bold;
  color: #3730a3;
  background: #eef2ff;
  font-size: 14px;
  line-height: 1.375;
  width: max-content;
  display: flex;
  // rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 text-base leading-snug w-max table-cell
}

.fs-10 .el-form-item__error {
  font-size: 10px;
}

.is-valid input {
  border: 1px solid red !important;
}

.error-span {
  color: red;
  font-size: 12px !important;
}

.router-item {
  overflow-y: scroll !important;
  min-height: 80vh;
}

.pt80 {
  padding: 80px 0px 0px 0px !important;
}

body {
  padding: 0;
  margin: 0;
  background: white;
  font-family: "Nunito", sans-serif !important;
}

.cp {
  cursor: pointer;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.d-flex {
  display: flex;
}

.h-40 {
  height: 40px;
  max-height: 40px;
}

.default-button {
  padding: 5px 0px !important;

  img {
    width: 100%;
  }
}

.w-40px {
  width: 40%;
}

.noborder {
  border: none !important;
}

.wrapper {
  padding: 20px;
  flex: 1;
  background-image: #fff;
  @media screen and (max-width: 1024px) {
    padding: 16px;
  }
  @media screen and (max-width: 575px) {
    padding: 8px;
  }
}

.el-input__inner {
  border-radius: 12px !important;
  font-weight: 600 !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
  box-shadow: 0px 1px 2px 0px #0000000d;
}

.el-input.is-disabled .el-input__inner {
  background-color: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
  cursor: not-allowed;
}

.el-form-item.is-error {
  .el-input__inner {
    border-color: #f56c6c !important;
  }
}
.border-radius-20 {
  border-radius: 20px !important;
}

.border-radius {
  .el-input__inner {
    border-radius: 10px !important;
  }
}

.actions {
  margin-top: 40px;

  .el-button {
    width: 100%;
    margin: 0;
    margin-bottom: 15px;
  }

  .primary {
    display: flex;
    justify-content: space-between;

    .el-button {
      width: calc(50% - 7.5px);
    }
  }
}

.wp-body {
  // background: #ffffff;
  // box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  // border-radius: 16px;
  // padding: 17px;
  overflow: hidden;
  /* padding-bottom: 40px; */
  min-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  // padding: 8px;
}

.color-primary {
  color: #3730a3 !important;
}

.new_build {
  background-color: #3730a3 !important;
  color: #fff !important;
}

.exist_build {
  background-color: #f1f5f9 !important;
  color: #475569 !important;
}

.primary-btn {
  background: #3730a3 !important;
  color: #fff !important;
  font-weight: 600;
}

.dark-btn {
  background: #000 !important;
  color: #fff !important;
  font-weight: 600;
}

.green-btn {
  background: rgb(20, 134, 20) !important;
  color: #fff !important;
}

.obj-name {
  font-weight: 800;
  font-size: 30px;
  line-height: 37px;
  padding-bottom: 10px;
  color: #3730a3;
}

.wp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 0 20px;

  .right {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .search {
    max-width: 600px;
    margin-left: 16px;
  }
  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
}

.mw-100 {
  min-width: 100px !important;
  flex: 1;
}
.interface-btn {
  padding: 8px;
  border-radius: 12px;
  .icon {
    width: 24px;
    height: 24px;
  }
  &:disabled {
    background: #e2e8f0 !important;
    color: white !important;
  }
}
.select_prefix {
  .el-input--prefix .el-input__inner {
    padding-left: 40px !important;
  }
  .el-input__prefix {
    left: 12px !important;
  }
  .el-input__inner {
    padding-left: 40px !important;
  }
}

.mTitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 37px;
  display: flex;
  align-items: center;
  color: #3730a3;
}

.mTitle2 {
  font-weight: 400;
  font-size: 24px;
  line-height: 37px;
  color: #3730a3;
}

.input-section {
  font-family: Montserrat;
  color: #1e293b;

  .item {
    display: block;
    margin-top: 12px;

    p {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      margin-bottom: 6px;
    }
  }
}

.build-num {
  width: 40px;
  height: 40px;
  margin-left: 18px;
  display: flex;
  background-color: #3730a3;
  box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
}

.el-alert {
  border-radius: 15px !important;
}

.text-area {
  textarea {
    height: 125px;
  }
}

.text-left {
  text-align: left !important;
}

.el-button {
  border-radius: 15px !important;
}

.el-button-download {
  border-radius: 10px !important;
  height: 30px !important;
  width: 30px !important;
  border: 1px solid #3730a3 !important;
  border-radius: 50% !important;
  color: #3730a3 !important;
  font-weight: 600 !important;
  padding: 5px !important;

  i {
    color: #3730a3;
    font-weight: 600 !important;
  }

  &::before {
    color: #3730a3;
  }

  &.danger {
    color: #ff3838;
    border: 1px solid #ff3838 !important;

    &::before {
      color: #ff3838 !important;
    }
  }
}

.back-button {
  padding: 10px 20px;
  font-weight: 600;
  background: #000;
  color: #fff;
  border-radius: 15px;
  font-size: 16px;
}

.is-disabled {
  opacity: 0.7 !important;
}

.wp-table {
  border-collapse: collapse;
  margin-top: 20px;
  width: 100%;

  thead {
    background-color: #eaeaea;
  }

  tbody tr td:last-child {
    .d-flex {
      justify-content: flex-end;
    }
  }

  td {
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid #d4d4d4;
  }
}

.el-pagination {
  padding-top: 15px !important;
}

.el-pager li {
  background: #f1f5f9 !important;
  color: #3730a3 !important;
  border-radius: 12px !important;
  border: none !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  margin: 0 4px !important;
}

.el-pager li.active {
  background: #3730a3 !important;
  color: #fff !important;
  font-weight: 600 !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  border-radius: 12px !important;
  line-height: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  background: #f1f5f9 !important;
  color: #3730a3 !important;
  margin: 0 4px !important;
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  font-size: 16px !important;
}
.el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  color: #94a3b8 !important;
}
.el-pagination__sizes {
  .el-input--mini .el-input__inner {
    height: 40px !important;
    line-height: 40px !important;
    padding-right: 40px !important;
    padding-left: 12px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .el-select .el-input .el-select__caret {
    color: #64748b !important;
    font-size: 18px !important;
    font-weight: 600 !important;
  }
  .el-input--mini .el-input__icon {
    line-height: 40px !important;
  }
}
.el-pagination .el-input__suffix {
  right: 12px !important;
}

.el-checkbox__inner {
  width: 16px !important;
  height: 16px !important;
  border-radius: 6px !important;
  padding: 4px !important;
  font-size: 16px !important;
  border: 1px solid #cbd5e1 !important;
  background: linear-gradient(135deg, #f2f2f2 0%, #ffffff 100%) !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #3730a3 !important;
  border: 1px solid #3730a3 !important;
}

.el-checkbox__inner::after {
  width: 4px !important;
  height: 8px !important;
  top: 1px !important;
  left: 5px !important;
  font-weight: 600 !important;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  top: 6px !important;
}

.el-breadcrumb {
  // font-size: 16px !important;
  color: #3730a3 !important;
  line-height: 1;
}

.el-table thead,
.el-table th {
  color: #1e293b !important;
  background-color: #f1f5f9 !important;
  font-weight: 700;

  &:first-child {
    border-radius: 12px 0 0 12px;
  }

  &:nth-last-child(2) {
    border-radius: 0 12px 12px 0;
  }
}

.el-radio {
  color: #606266 !important;
  cursor: pointer;
  margin-right: 0 !important;
  border-radius: 15px;
}

.el-radio.is-bordered {
  padding: 12px 16px 0 16px !important;
  border-radius: 15px !important;
  border: none !important;
  background: #f8fafc !important;
  color: #1e293b !important;
}

.el-radio.is-bordered.is-checked {
  border: none !important;
  color: #3730a3 !important;
  background: #eef2ff !important;
}

.prim .el-radio__input.is-checked + .el-radio__label {
  color: #fff !important;
  font-size: 16px;
  padding-top: 2px !important;
}

.prim .el-radio__input.is-checked .el-radio__inner {
  border-color: #3730a3 !important;
  background: #fff !important;
}

.el-radio__inner {
  width: 16px !important;
  height: 16px !important;
  background: #fff !important;
  border: 2px solid #3730a3 !important;
}

.el-radio__inner::after {
  width: 8px !important;
  height: 8px !important;
  background: #3730a3 !important;
}

.el-pagination .el-select .el-input {
  width: 170px !important;
  margin: 0 5px;
}

// .final {
//   .el-input__inner {
//     border-color: #67C23A;
//     color:#67C23A;
//   }
// }
.el-table__expand-icon {
  margin-right: 10px !important;
}

// .el-icon-arrow-right {
//     color: blue !important;
//     font-size: 14px !important;
//     font-weight: 600;
// }

// fixed

.fixed-item {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(30px);
}

.fixed-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.8;
  z-index: 0;
}

.pr {
  position: relative;
}

.kt-button {
  padding: 10px 25px;
  border-radius: 5px;
  font-weight: 600;
}

.error input {
  border-color: #e11d48 !important;
  color: #e11d48;
}

.error span::after {
  color: #e11d48 !important;
}

.connecting input {
  border-color: #d97706 !important;
}

.succes input {
  border-color: #059669 !important;
  color: #059669;
}

.about-knumber {
  position: absolute;
  bottom: 30px;
  right: 30px;
  z-index: 1;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.about-knumber button {
  outline: none !important;
}

.k-input {
  font-size: 14px !important;
}

.k-input-paret {
  display: flex;
  align-items: center;
  gap: 4px;
}

.kadaster-item {
  max-width: 600px;
}

.border-red input {
  border-color: red;
  color: red;
  outline: none;
}

.erorrsk {
  width: 100%;
  padding: 10px 16px;
  margin-bottom: 20px;
  background: #fff1f2;
  color: #e11d48;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
}

.warningk {
  width: 100%;
  padding: 10px 16px;
  margin-bottom: 20px;
  background: #fff7ed;
  color: #d97706;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
}

.uncompletek {
  width: 100%;
  padding: 10px 16px;
  margin-bottom: 20px;
  background: #ecfdf5;
  color: #059669;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
}

.succesk {
  width: 100%;
  padding: 10px 16px;
  margin-bottom: 20px;
  background: #ecfdf5;
  color: #059669;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
}

.erorr-status .el-radio.is-bordered {
  border-color: red !important;
}

.fw-w {
  flex-wrap: wrap !important;
}

.bg10 {
  background: #02b102;
}

.c-green {
  color: #0ad668;
  font-weight: 600 !important;
}

.c-red {
  color: #ff3838 !important;
  font-weight: 600 !important;
}

.c-yellow {
  color: #c4e300 !important;
  font-weight: 600 !important;
}

.c-primary {
  color: #3730a3;
}

.bb .el-input__inner {
  border: 1px solid rgb(100, 100, 100) !important;
}

.bb .el-input__inner::placeholder {
  color: rgb(100, 100, 100) !important;
  opacity: 1 !important;
}

.bb .el-input__icon {
  color: rgb(100, 100, 100) !important;
}

.upload-file {
  width: 100%;

  .upload-file-text {
    display: flex;

    button {
      background: #3730a3;
      color: #fff;
      font-weight: 600;
      position: relative;
      min-width: 150px;
      width: 150px;
      font-size: 12px;
      max-height: 40px;
      cursor: pointer;
      padding: 5px 10px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 15px;

      input {
        position: absolute !important;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }

    p {
      font-size: 16px;
      line-height: 20px;
    }
  }

  .upload-file-list {
    padding-top: 15px;
  }

  .upload-file-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 5px;

    p {
      flex: 1;
      padding-right: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    button {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      cursor: pointer;
      font-size: 18px;
    }

    .upload-success {
      color: #02b102;
    }

    .upload-delete {
      color: red;
      display: none;
    }

    .upload-progress {
      display: none;
    }

    .contols-upload:hover {
      .upload-success {
        display: none;
      }

      .upload-delete {
        display: block;
      }
    }

    &.progress {
      .upload-success {
        display: none;
      }

      .upload-progress {
        display: block;
      }

      .contols-upload:hover {
        .upload-delete {
          display: none;
        }
      }
    }
  }

  .disabled {
    .upload-file-list-item {
      .contols-upload:hover {
        .upload-success {
          display: block;
        }

        .upload-delete {
          display: none;
        }
      }
    }
  }

  .file-Size {
    padding-top: 10px;
    text-align: right;
    color: green;
  }
}

.el-loading-spinner {
  text-align: center;
}
.add__button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 12px;
  background: #10b981;
  color: white;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  transition: background 0.3s ease;
  outline: none;

  &:hover {
    background: #059669;
  }
  &:disabled {
    background: #e2e8f0;
    color: #475569;
    cursor: not-allowed;
    .icon {
      color: #94a3b8;
    }
  }
}

// .el-table .warning-row {
//   background: rgb(245, 219, 219) !important;
// }

//  .el-table .success-row {
//   background: rgb(226, 243, 224) !important;
// }

.bb0 {
  border-bottom: 0px;
}

.mha {
  min-height: auto !important;
}

.el-table .el-table__header .has-gutter .cell {
  word-wrap: normal !important;
  word-break: normal !important;
  display: flex;
  align-items: center;
  line-height: 19px;
  padding-top: 5px;
  padding-bottom: 5px;
  text-transform: uppercase;
}
.el-table th.el-table__cell > .cell {
  text-transform: uppercase;
}
.el-table .el-table__cell.is-center .cell {
  justify-content: center;
}

.el-table .cell {
  // word-wrap: normal !important;
  word-break: normal !important;
}
.spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* accessibility: agar foydalanuvchi reduced motion istasa, animni o'chirish */
@media (prefers-reduced-motion: reduce) {
  .spin {
    animation: none;
  }
}

.button {
  padding: 10px 20px !important;
  border-radius: 15px !important;
  font-size: 14px;

  &.black {
    color: #fff;
    background: black;
  }

  &.purple {
    color: #fff;
    background: #6366f1;
  }

  &.dark-blue {
    background: #3730a3;
    color: #fff;
    font-weight: 600;
  }

  &.add__button {
    background: #10b981;
    color: #fff;
    font-weight: 600;
  }
}

.fw-600 {
  font-weight: 600 !important;
}

.fw-500 {
  font-weight: 500 !important;
}

.fs-20 {
  font-size: 20px;
}

.c-dark-blue {
  color: #3730a3 !important;
}

.pdf-control {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px 20px;
}

.pdf {
  overflow-y: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  width: 100%;
  position: relative;
  min-height: 500px;
}

.loading-pdf {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.see_button {
  background: #eef2ff;
  color: #3730a3;
  transition: all 0.3s ease;

  &:hover {
    background: #e0e7ff;
  }

  &:disabled {
    background: #e2e8f0;
    color: #ffffff;
  }
}

.print {
  padding: 10px 20px;
  background: #3730a3;
  color: #fff;
  border-radius: 15px;
  font-weight: 600;
  font-size: 14px;
}

.play-pause-layer {
  display: none;
}

.table-link-button {
  font-weight: 600;
  cursor: pointer;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.h-full {
  min-height: 100%;
  height: 100%;
}

.responsive-btn {
  padding: 15px;
}

@media screen and (max-width: 750px) {
  .modal-item {
    width: 100%;
    padding: 80px 20px 120px 20px;
  }

  .responsive-btn {
    padding: 10px;
    font-size: 12px !important;
  }
}

.user-modal-body {
  .el-radio__label {
    padding-left: 2px;
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 4px;
  }
}
.prime-radio-group {
  .el-radio.is-bordered {
    background: #f1f5f9 !important;
  }
  .el-radio__inner {
    border-color: #94a3b8 !important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: white !important;
    background: #3730a3 !important;
  }
  .el-radio__inner::after {
    background: white !important;
  }
  .el-radio.is-bordered.is-checked {
    background: #3730a3 !important;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: white !important;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  .is-disabled {
    opacity: 1 !important;
  }
  .el-radio.is-checked.is-disabled {
    background: #94a3b8 !important;
  }
  .el-radio__input.is-checked.is-disabled .el-radio__inner {
    background: #94a3b8 !important;
  }
  // .el-radio__inner {
  //   border-color: white !important;
  // }
}

.page__card {
  background: #ffffff;
  padding: 20px;
  border-radius: 20px;

  &-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    h1 {
      color: #020617;
      font-weight: 700;
      font-size: 24px;
      line-height: 33px;
      flex: 1;
    }
  }
  @media screen and (max-width: 1024px) {
    padding: 16px;
    border-radius: 12px;
    &-title {
      margin-bottom: 10px;
      h1 {
        font-size: 20px;
      }
    }
  }
  @media screen and (max-width: 575px) {
    padding: 12px;
    border-radius: 8px;
  }
}
.el-dialog__header {
  padding: 28px 28px 20px !important;
  @media screen and (max-width: 575px) {
    padding: 16px 16px 12px !important;
  }
}
.el-dialog__title {
  font-weight: 700;
  font-size: 24px !important;
  line-height: 1.375 !important;
  color: #020617 !important;
  @media screen and (max-width: 575px) {
    font-size: 20px !important;
  }
}
.el-dialog__body {
  padding: 0 28px 28px !important;
  @media screen and (max-width: 575px) {
    padding: 0 16px 16px !important;
  }
}
.el-dialog__footer {
  padding: 10px 28px 28px !important;
  @media screen and (max-width: 575px) {
    padding: 10px 16px 16px !important;
  }
  .el-button {
    border-radius: 12px !important;
    border: none !important;
    padding: 8px 16px !important;
    min-height: 40px;
    font-size: 16px;
    line-height: 22px;
  }
  .el-button--default {
    background: #f8fafc;
    color: #1e293b !important;
    &:hover {
      background: #f1f5f9;
    }
  }
  .el-button--primary {
    background: #3730a3;
    color: white !important;
    &:hover,
    &:focus {
      background: #4338ca !important;
    }
  }
}
.finalconclusion {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
.fc__bg-4 {
  background: #e11d48;
}
.fc__bg-3 {
  background: #f59e0b;
}
.fc__bg-2 {
  background: #84cc16;
}
.fc__bg-1 {
  background: #10b981;
}
.secondary-btn {
  background: #eef2ff;
  color: #1e293b;
  border-radius: 12px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
  &:hover {
    background: #e0e7ff;
  }
  .icon {
    color: #3730a3;
  }
}
.primary-button {
  background: #3730a3;
  color: #ffffff;
  border-radius: 12px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
  &:hover {
    background: #4338ca;
  }
}
.light-button {
  background: #f8fafc;
  color: #1e293b;
  border-radius: 12px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-size: 16px;
  line-height: 1.375;
  font-weight: 600;
  &:hover {
    background: #f1f5f9;
  }
}
</style>
<style scoped>
.config-cadaster {
  position: fixed;
  width: 100vw;
  max-height: 100vh;
  height: 100vh;
  left: 0;
  overflow: auto;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  box-sizing: border-box;
  padding: 20px 0px;
}

.cadastre-scroll {
  padding: 50px 10px;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
}

.config-cadaster-item {
  max-width: 500px;
}

.title-config {
  font-weight: 600;
  margin-bottom: 20px;
  font-size: 20px;
  text-align: center;
}

.config-text {
  font-size: 14px;
  font-weight: 500;
  margin: 2px 0px;
}

.config-text td {
  padding: 1px 5px 1px 0px;
}

.title2-config {
  font-size: 18px;
  margin: 5px 0px;
  font-weight: 500;
}

.config-text2 {
  margin: 10px 0px;
  font-size: 16px;
  font-weight: 500;
  color: green;
  text-align: center;
}

.config-button {
  padding: 15px 20px;
  font-weight: 500;
  background: #3730a3 !important;
  color: #fff;
  margin-top: 10px;
  border-radius: 15px;
}

.router-content {
  position: relative;
  min-height: calc(100vh - 80px);
  /* padding: 10px 10px 0px 10px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pb-80 {
  padding-bottom: 80px;
}

.app-footer-container {
  padding: 0 20px 20px;
  @media screen and (max-width: 575px) {
    padding: 0 8px 8px;
  }
}

.nav-bottom {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
}

.unicon-link {
  display: flex;
}

.owf-h {
  overflow: hidden !important;
}

.el-select-dropdown__item {
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  width: 160px !important;
  height: 1.2em !important;
  white-space: nowrap !important;
  color: red !important;
}

/* TAPLE */

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-color: #fff !important;
}
</style>
